module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1 pure-u-md-5-6 pure-u-lg-3-4 pure-u-xl-2-3 container"
  }, [_c('app-header'), _vm._v(" "), (_vm.isCalendarVisible) ? _c('Calendar', {
    attrs: {
      "year": _vm.year,
      "month": _vm.month
    },
    on: {
      "updateMonthYear": _vm.updateMonthYear,
      "selectDate": _vm.selectDate
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('Note', {
    staticClass: "pure-u-1",
    attrs: {
      "year": _vm.date.year,
      "month": _vm.date.month,
      "date": _vm.date.date
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00525278"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage.vue
// module id = 115
// module chunks = 1